module.exports = __webpack_public_path__ + "static/ilustra_pitch-6e8803c1476d2484447ce462709ba6a9.png";